<template>
	<div id="_app" :class="{ 'matching-route': store.blockUi }">
		<!-- display: none keeps the app mounted (unsaved editor state survives) but takes it out of the tab order
		     and the accessibility tree while the chunk error is shown. -->
		<div v-show="!chunkLoadFailed" class="app-content">
			<router-view />
			<alert />
			<loading-state />
		</div>
		<chunk-load-error />
	</div>
</template>

<script setup lang="ts">

import { onMounted } from 'vue';
import { useRoute } from 'vue-router';

import { chunkLoadFailed } from "./chunkLoadFailure";
import ChunkLoadError from "./components/ChunkLoadError.vue";
import Alert from "./components/editor/Alert.vue";
import LoadingState from './components/player/LoadingState.vue';
import { useStore } from './store/Store';

const store = useStore();
const route = useRoute();

onMounted(() => {
	setTimeout(() => {
		//@ts-ignore
		window.prerenderReady = true;
	}, 2000);

	if (route?.query?.videoMode) {
		store.videoMode = true;
	}
	window["toggleVideoMode"] = () => {
		store.videoMode = !store.videoMode;
	}
});

</script>

<style>
#_app {
	/* font-family: 'Avenir', Helvetica, Arial, sans-serif !important; */
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;

	display: flex;
	flex-flow: column nowrap;
	align-items: center;

}

.app-content {
	display: contents;
}

#_app>h2,
#_app>h1 {
	color: #eee
}

.maplibregl-map,
body {
	font-family: 'Poppins', sans-serif;
}


/* cover that blocks mouse events and adds progress cursor
   while matching route. */
.matching-route:after {
	cursor: progress !important;
	content: '';
	position: absolute;
	width: 100%;
	height: 100%;
	top: 0;
	left: 0;
	z-index: 5000;
}
</style>
